"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = Features;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _features = _interopRequireDefault(require("./features.css"));
function Features(_ref) {
  var features = _ref.features,
    theme = _ref.theme,
    disclaimerData = _ref.disclaimerData;
  return features.length ? /*#__PURE__*/_react["default"].createElement("ul", {
    className: "" + _features["default"].features
  }, features.map(function (feature) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: feature.label,
      className: _features["default"].feature
    }, feature.icon && /*#__PURE__*/_react["default"].createElement("span", {
      className: theme["mmcIcon" + feature.icon] + " " + _features["default"].iconImage
    }), feature.label && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: feature.label,
      tag: "p",
      disclaimerData: disclaimerData
    }));
  })) : null;
}
Features.defaultProps = {
  features: []
};